import { render, staticRenderFns } from "./product-unit-of-measure.vue?vue&type=template&id=1150cc1b&"
import script from "./product-unit-of-measure.vue?vue&type=script&lang=js&"
export * from "./product-unit-of-measure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports